import { render, staticRenderFns } from "./TopVideosList.vue?vue&type=template&id=9ca21cd0&scoped=true&"
import script from "./TopVideosList.vue?vue&type=script&lang=js&"
export * from "./TopVideosList.vue?vue&type=script&lang=js&"
import style0 from "./TopVideosList.vue?vue&type=style&index=0&id=9ca21cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca21cd0",
  null
  
)

export default component.exports